import {Injectable, Type} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {UfFlowObjectDto} from '../../../model/dto/entity/uf-flow-object.dto';
import {MvsCrudService} from '../../../../../core/shared/service/crud/mvs-crud.service';
import {MvsCrudModeEnum} from '../../../../../core/shared/service/crud/mvs-crud-mode.enum';
import {ObjectRequestList} from '../../../../../core/shared/dto/object/request/object-request-list';
import {FilterCriteria} from '../../../../../core/shared/filter/api/filter.criteria';
import {Sorting} from '../../../../../core/shared/misc/sorting';
import {DtoList} from '../../../../../core/shared/dto/dto.list';

@Injectable({
    providedIn: 'root'
})
export class UfFlowObjectService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/uf/flowObjects');
    }

    getObjectComponent(mode: MvsCrudModeEnum = MvsCrudModeEnum.update): Type<any> {
        return null;
    }

    public listObjectsForFlow(flowId: number): Observable<DtoList> {
        return this.list(new ObjectRequestList(
            true,
            [FilterCriteria.create('flow.id', FilterCriteria.cOperatorEqual, flowId)],
            [new Sorting('orderIndex', true)]
        ));
    }

    public listObjectsForFlowAndRole(flowId: number, roleId: number): Observable<DtoList> {
        return this.list(new ObjectRequestList(
            true,
            [
                FilterCriteria.create('flow.id', FilterCriteria.cOperatorEqual, flowId),
                FilterCriteria.create('objectRole.id', FilterCriteria.cOperatorEqual, roleId)
            ],
            [new Sorting('orderIndex', true)]
        ));
    }

    public updateSelection(flowObjectId: number, selected: boolean): Observable<UfFlowObjectDto> {
        const updateDto = new UfFlowObjectDto();
        updateDto.id = flowObjectId;
        updateDto.selected = selected;
        return <Observable<UfFlowObjectDto>>this.update(updateDto);
    }
}
